export const SET_MY_PRO_REVIEWS = 'set_my_pro_reviews';
export const SET_EARNINGS = 'set_earnings';
